import { useEffect, useState } from "react";

/**
 * タイプ → 完了したら静的テキストに自動で置き換え
 * keepCursor=true なら完了後もカーソルを点滅させ続ける
 */
export default function Typewriter({
  text,
  speed = 35,
  startDelay = 0,
  className,
  keepCursor = false,
  onDone,
  showCursorBeforeStart = false, // ← 追加: 待機中にカーソルを出すか（既定は出さない）
}) {
  const [i, setI] = useState(0);
  const [typing, setTyping] = useState(false);
  const [done, setDone] = useState(false);

  // 遅延開始
  useEffect(() => {
    const id = setTimeout(() => setTyping(true), startDelay);
    return () => clearTimeout(id);
  }, [startDelay]);

  // タイピング進行
  useEffect(() => {
    if (!typing || done) return;
    if (i < text.length) {
      const id = setTimeout(() => setI(i + 1), speed);
      return () => clearTimeout(id);
    } else {
      setDone(true);
      onDone?.();
    }
  }, [typing, done, i, text, speed, onDone]);

  // ① 完了後：テキスト固定（必要ならカーソルを残す）
  if (done) {
    return (
      <span className={`typewriter ${className || ""}`}>
        {text}
        {keepCursor && <span className="caret">|</span>}
      </span>
    );
  }

  // ② 未開始（startDelay待ち）：既定はカーソルを出さない
  if (!typing) {
    return (
      <span className={`typewriter ${className || ""}`}>
        {showCursorBeforeStart ? <span className="caret">|</span> : null}
      </span>
    );
  }

  // ③ タイプ中：カーソル表示
  return (
    <span className={`typewriter ${className || ""}`}>
      {text.slice(0, i)}
      <span className="caret">|</span>
    </span>
  );
}
